import {
  LayoutGrid,
  FileText,
  Globe,
  Folder,
  Megaphone,
  Lightbulb,
  Briefcase,
  Users,
  Building2,
  PieChart,
  GraduationCap,
  Tag,
  Share2,
} from "lucide-react";
import { MenuItem } from "./types";

export const menuItems: MenuItem[] = [
  { id: "dashboard", label: "Bảng điều khiển", icon: LayoutGrid },
  {
    id: "topics",
    label: "Đề tài, nhiệm vụ KH&CN",
    icon: FileText,
    hasSubmenu: true,
    subItems: [
      "Xét duyệt thuyết minh",
      "Đề tài đang triển khai",
      "Đề tài hoàn thành",
      "Đề tài không hoàn thành",
    ],
  },
  {
    id: "cooperation",
    label: "Hợp tác quốc tế",
    icon: Globe,
    hasSubmenu: true,
    subItems: [
      "Tổ chức hợp tác",
      "Đoàn vào",
      "Đoàn ra",
      "Cán bộ nước ngoài",
      "Hội nghị, hội thảo",
    ],
  },
  {
    id: "documents",
    label: "Quản lý văn bản",
    icon: Folder,
    hasSubmenu: true,
    subItems: [
      "Danh sách văn bản",
      {
        id: "incoming",
        label: "Văn bản đến",
        hasSubmenu: true,
        subItems: [
          "Văn bản đến chưa xử lý",
          "Văn bản đến được giao",
          "Văn bản đến giao đọc",
        ],
      },
      {
        id: "outgoing",
        label: "Văn bản đi",
        hasSubmenu: true,
        subItems: [
          "Văn bản đi chưa xử lý",
          "Văn bản đi được giao",
          "Văn bản đi giao đọc",
        ],
      },
      "Văn bản pháp quy",
      "Nhóm nhận văn bản",
    ],
  },
  {
    id: "articles",
    label: "Bài báo - Công trình khoa học",
    icon: Megaphone,
    hasSubmenu: true,
  },
  {
    id: "initiatives",
    label: "Sáng kiến kinh nghiệm",
    icon: Lightbulb,
    hasSubmenu: true,
  },
  {
    id: "intellectual",
    label: "Sản phẩm sở hữu trí tuệ",
    icon: Briefcase,
    hasSubmenu: true,
  },
  {
    id: "contracts",
    label: "Hợp đồng - dịch vụ KH&CN",
    icon: FileText,
    hasSubmenu: true,
  },
  {
    id: "council",
    label: "Hội đồng - Chuyên gia",
    icon: Users,
    hasSubmenu: true,
    subItems: ["Danh sách Hội đồng", "Danh sách chuyên gia"],
  },
  {
    id: "organization",
    label: "Tổ chức - Nhân sự",
    icon: Building2,
    hasSubmenu: true,
    subItems: [
      "Lý lịch khoa học",
      "Tổng hợp nhân sự theo trình độ của cán bộ",
      "Tổng hợp nhân sự theo chức danh nghiên cứu",
    ],
  },
  {
    id: "statistics",
    label: "Thống kê - Báo cáo",
    icon: PieChart,
    hasSubmenu: true,
    subItems: [
      "Thống kê tổng quan",
      "Tình hình sử dụng Kinh phí",
      "Báo cáo tiến độ đề tài NCKH",
      "Tiến độ thực hiện đề tài",
      "Thống kê Đề tài, nhiệm vụ KHCN",
    ],
  },
  { id: "awards", label: "Khen thưởng", icon: GraduationCap, hasSubmenu: true },
  {
    id: "equipment",
    label: "Quản lý trang thiết bị",
    icon: Tag,
    hasSubmenu: true,
  },
  {
    id: "standards",
    label: "Quản lý tiêu chuẩn",
    icon: Share2,
    hasSubmenu: true,
  },
  {
    id: "members",
    label: "Thành viên",
    icon: Users,
    hasSubmenu: true,
    subItems: ["Danh sách thành viên", "Xem với tư cách khoa"],
  },
];
